module.exports = __webpack_public_path__ + "img/pleisure_bodyimage03-3.bc54a3a9.jpg";